import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建优惠券 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("满减券")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("折扣券")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { style: {"font-size":"12px"} }
const _hoisted_16 = { class: "text-success" }
const _hoisted_17 = { class: "text-muted ms-2" }
const _hoisted_18 = { style: {"font-size":"12px"} }
const _hoisted_19 = { class: "text-danger" }
const _hoisted_20 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_21 = { style: {"font-size":"12px"} }
const _hoisted_22 = { style: {"font-size":"12px"} }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("使用情况")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("发放")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_GrantModal = _resolveComponent("GrantModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "name",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                placeholder: "优惠券名称"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "coupon_type",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.coupon_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.coupon_type) = $event)),
                placeholder: "优惠券类型",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "满减券",
                    value: "fixed"
                  }),
                  _createVNode(_component_el_option, {
                    label: "折扣券",
                    value: "percent"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "status",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.status) = $event)),
                placeholder: "状态",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部",
                    value: ""
                  }),
                  _createVNode(_component_el_option, {
                    label: "启用",
                    value: "active"
                  }),
                  _createVNode(_component_el_option, {
                    label: "停用",
                    value: "inactive"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'lottery_coupon_new' },
                class: "btn btn-success ms-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "60"
        }),
        _createVNode(_component_vxe_column, {
          field: "name",
          title: "名称",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "类型",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.coupon_type === 'fixed')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : (row.coupon_type === 'percent')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "优惠内容",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.discount_text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "使用门槛",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.min_amount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "满" + _toDisplayString(row.min_amount) + "元", 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "无门槛"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "适用套系",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.box_info_text)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.box_info_text), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "全部套系"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "适用抽数",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.times_text)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.times_text), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, "全部抽数"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "领取/总量",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.claimed_quantity), 1),
            _createElementVNode("span", _hoisted_14, "/" + _toDisplayString(row.total_quantity || '不限'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "使用情况",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.stats)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, "已用:" + _toDisplayString(row.stats.total_used), 1),
                    _createElementVNode("span", _hoisted_17, "未用:" + _toDisplayString(row.stats.total_unused), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, "过期:" + _toDisplayString(row.stats.total_expired), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "有效期",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            (row.start_time && row.end_time)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(row.start_time)), 1),
                  _createElementVNode("div", _hoisted_22, "至 " + _toDisplayString(_ctx.formatDate(row.end_time)), 1)
                ], 64))
              : (row.validity_days)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "领取后" + _toDisplayString(row.validity_days) + "天有效", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_24, "长期有效"))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 'active')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "创建时间",
          width: "160"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "230",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'lottery_coupon_edit', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "info",
              size: "small",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'lottery_coupon_usage', params: { id: row.id } }))
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "success",
              size: "small",
              onClick: ($event: any) => (_ctx.openGrantModal(row))
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_GrantModal, {
      visible: _ctx.grantModalVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.grantModalVisible) = $event)),
      coupon: _ctx.selectedCoupon,
      onSuccess: _ctx.onGrantSuccess
    }, null, 8, ["visible", "coupon", "onSuccess"])
  ]))
}